import { Moment } from 'moment';

const WINDOW_MINUTES = 30;

export const calculateWindowStart = (requestedDeliveryDate: Moment) =>
  requestedDeliveryDate.clone()
    .subtract(WINDOW_MINUTES, 'minutes');
